export const PURCHASE_TYPE = {
  OTP: 'one-time',
  SUBSCRIPTION: 'subscription'
};
